import { userContext } from '../userManager';

export const apiPeerCategoriesGet = () => userContext.apiCall({ url: `/peer-categories` });

export const apiPeerCategoriesInstrumentsGet = (peerCategoryId) =>
  userContext.apiCall({ url: `/peer-categories/${peerCategoryId}/instruments` });
